import styled from "styled-components";

export const AttachmentsUploadBox = styled.div`
  margin-top: 20px;
  box-sizing: border-box;
  background: ${({ isDraggingOver, theme }) =>
    isDraggingOver ? `${theme.bg.brand}22` : theme.bg.primary};
  border-radius: 4px;
  padding: 25px 0px;
  text-align: center;

  cursor: ${({ isDisabled }) => (isDisabled ? "no-drop" : "default")};
  opacity: ${({ isDisabled }) => (isDisabled ? "0.5" : "1")};

  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 20px;

  border: 1px dashed
    ${({ isDraggingOver, theme }) =>
      isDraggingOver ? theme.bg.brand : theme.bg.hover};
`;

export const AttachmentsTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.text.title};
`;

export const AttachmentsDesc = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.text.title};
`;

export const AttachmentsLink = styled.label`
  color: ${({ theme }) => theme.text.title};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  text-decoration: underline;
`;

export const AlertContainer = styled.div`
  padding-top: 15px;
`;

export const AlertMsg = styled.div`
  font-size: 14px;
  line-height: 14px;
  color: #07145a;

  display: flex;
  align-items: center;
  column-gap: 15px;
`;
